import { useMemberState } from '@/hooks/useMemberState'
import { useCapabilitiesStore } from '@/stores/capabilities'

/**
 * returns whether the corresponding button should be visible and enabled
 * based on the capabilities and the current state
 * - button `visible` if one of the `capabilities` is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useMemberVideoButtonState = (memberId: string) => {
  const memberVideoMuted = useMemberState({
    memberId,
    subscriptionKey: 'videoMuted',
  })
  const memberVideoCapabilityOff = useCapabilitiesStore(
    state => state.memberVideoCapabilityOff,
  )
  const memberVideoCapabilityOn = useCapabilitiesStore(
    state => state.memberVideoCapabilityOn,
  )

  // button visible if one of the capabilities is enabled
  const isVideoButtonVisible =
    memberVideoCapabilityOn || memberVideoCapabilityOff

  // muted and can unmute
  const canUnmute = memberVideoMuted && memberVideoCapabilityOn
  // unmuted and can mute
  const canMute = !memberVideoMuted && memberVideoCapabilityOff

  // check if button can perform the necessary next action
  const isVideoEnabled = canUnmute || canMute

  return { isVideoButtonVisible, isVideoEnabled }
}
